import React from "react";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const AvanceProyectosChartBarras = ({ data }) => {
    const proyectos = data.map((item) => item.codigo);
    const avanceProgramado = data.map((item) => Math.round(parseFloat(item.total_meta)));
    const avanceEjecutado = data.map((item) => Math.round(parseFloat(item.total_meta_ejecutada)));
    const metadata = data.map(item => ({
        grupoterritorial: item.grupoterritorial,
        implementador: item.implementador,
    }));

    const chartData = {
        labels: proyectos,
        datasets: [
            {
                label: "Meta Programada (P)",
                data: avanceProgramado,
                backgroundColor: "rgba(54, 162, 235, 0.7)",
                metadata
            },
            {
                label: "Meta Ejecutada (E)",
                data: avanceEjecutado,
                backgroundColor: "rgba(255, 165, 0, 0.6)",
                metadata
            },
        ],
    };

    const options = {
        responsive: false,              // ❌ desactivamos responsive
        maintainAspectRatio: false,     // ❌ para que respete el height que le pasamos
        indexAxis: "y",
        scales: {
            x: { beginAtZero: true, max: 40 },
        },
        elements: {
            bar: {
                barThickness: 30,           // barras más gruesas
            }
        },
        plugins: {
            legend: { position: "top" },
            tooltip: {
                callbacks: {
                    label: ({ dataIndex, dataset, raw, label }) => {
                        const meta = dataset.metadata[dataIndex];
                        return [
                            `${label}: ${raw}`,
                            `Grupo territorial: ${meta.grupoterritorial}`,
                            `Implementador: ${meta.implementador}`
                        ];
                    }
                }
            }
        }
    };

    // 25px por barra de alto (ajusta a tu gusto)
    const canvasHeight = data.length * 30; // 30px por barra + 50px de margen

    return (
        <div
            style={{
                height: '100%',           // altura visible antes de hacer scroll
                overflowY: "auto",
                padding: "0 16px",

            }}
        >
            <Bar
                data={chartData}
                options={options}
                height={canvasHeight}
                width={600} // Ancho fijo para evitar que se estire


            />
        </div>
    );
};

export default AvanceProyectosChartBarras;
